/**
 * This is helper class will be utilized for KMSearch configuration
 */
import _isEmpty from 'lodash/isEmpty';
import Page from './page';

// Get Remote config for KMSearch config from window
const getKMSearchConfig = () => {
  try {
    if (window && window.kmSearchConfig) {
      return window.kmSearchConfig;
    }
    return {};
  } catch (e) {
    return {};
  }
};

// this funciton is used to validate whether KMSearch is fully global or not ?
export const isKMSearchEnabledGlobally = () => {
  const config = getKMSearchConfig();
  if (!_isEmpty(config)) {
    return (config.enableSearchGlobally || false);
  }
  return false;
};

// Check if current locale is COVID BCP affected.
export const isMarketEnabledForKMSearch = () => {
  const country = (Page.getCountry()).toUpperCase();
  const locale = Page.getAPILocalilty();
  const kmSearchConfig = getKMSearchConfig();
  if (!_isEmpty(kmSearchConfig)) {
    if (kmSearchConfig.kmSearchEnabledMarkets) {
      return kmSearchConfig.kmSearchEnabledMarkets.split(',')
        .filter((market) => market.indexOf(`${country}:`) >= 0)
        .filter((selectedMarket) => selectedMarket.split(':')[1].indexOf(locale) >= 0)
        .length > 0;
    }
  }
  return false;
};

export const isKMSearchEnabled = () => {
  if (isKMSearchEnabledGlobally() || isMarketEnabledForKMSearch()) return true;
  // default return false;
  return false;
};
